// Variant Price Patch — House of SYREN

(function () {
  var PRODUCT_HANDLE = window.location.pathname.split('/products/')[1]?.split('?')[0];
  if (!PRODUCT_HANDLE) return;

  var lastKey = null;
  var productCache = null;

  function getSelectedValues() {
    var result = {};
    document.querySelectorAll('variant-picker fieldset input:checked').forEach(function(input) {
      var optionName = input.name.split('-')[0];
      result[optionName] = input.value;
    });
    return result;
  }

  function patchPrice(values, product) {
    var o1name = product.options[0].name; // Color
    var o2name = product.options[1].name; // Style
    var o3name = product.options[2].name; // Size

    console.log('[SYREN] matching:', values[o1name], values[o2name], values[o3name]);

    var match = product.variants.find(function(v) {
      return v.option1 === values[o1name] &&
             v.option2 === values[o2name] &&
             v.option3 === values[o3name];
    });

    console.log('[SYREN] match:', match?.id, match?.price);
    if (!match) return;

    fetch('/products/' + PRODUCT_HANDLE + '?variant=' + match.id, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var newContainers = doc.querySelectorAll('[ref="priceContainer"]');
      document.querySelectorAll('[ref="priceContainer"]').forEach(function(container, i) {
        if (newContainers[i]) container.innerHTML = newContainers[i].innerHTML;
      });

      var newSticky = doc.querySelector('.sticky-add-to-cart__price');
      var sticky = document.querySelector('.sticky-add-to-cart__price');
      if (sticky && newSticky) sticky.innerHTML = newSticky.innerHTML;

      console.log('[SYREN] price patched:', match.price);
    });
  }

  function poll() {
    var values = getSelectedValues();
    var key = JSON.stringify(values);
    if (key === lastKey || Object.keys(values).length === 0) return;
    lastKey = key;

    if (!productCache) {
      fetch('/products/' + PRODUCT_HANDLE + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          productCache = product;
          setTimeout(function() { patchPrice(getSelectedValues(), product); }, 800);
        });
    } else {
      setTimeout(function() { patchPrice(getSelectedValues(), productCache); }, 800);
    }
  }

  window.addEventListener('load', function() {
    setInterval(poll, 300);
  });

})();
